module.exports = ".logout-menu li {\r\n    border-bottom:1px solid #ccc;\r\n}"